import React from "react";
import Card from "@/components/Card";
import { Col, Row } from "antd";
import PyfolioChart from "./PyfolioChart";

export default () => (
  <Row gutter={[16, 16]}>
    <Col span={24}>
      <Card title="Cumulative Return" bordered={true}>
        <PyfolioChart
          target={"portfolioCummulativeReturn"}
          chartType={"Cumulative Return"}
          isCumReturn={true}
        />
      </Card>
    </Col>
    <Col span={12}>
      <Card title="Sharpe Ratio" bordered={true}>
        <PyfolioChart
          target={"portfolioRollingSharpe"}
          chartType={"Sharpe Ratio"}
          isCumReturn={false}
        />
      </Card>
    </Col>
    <Col span={12}>
      <Card title="Volatility" bordered={true}>
        <PyfolioChart
          target={"portfolioRollingVolatility"}
          chartType={"Volatility"}
          isCumReturn={false}
        />
      </Card>
    </Col>
  </Row>
)
